import { DataTableColumn } from '../../components/table-view/TableView';
import { Badge } from '../../components/badge';

export const usersColumn: DataTableColumn[] = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    sortable: true
  },
  {
    title: 'Administrator Name',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    sortable: true,
    render: ({ label, value }) => (
      <Badge
        label={label}
        variant={value}
        sx={{
          fontWeight: '500 !important'
        }}
      />
    )
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email'
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone'
  },
  {
    title: 'Role',
    dataIndex: 'role',
    key: 'role'
  }
];

export const usersData = [
  {
    id: '257229',
    name: 'Theresa Webb',
    status: { label: 'Active', value: 'active' },
    email: 'theresa.webb@gmail.com',
    phone: '(704) 555-0127',
    role: 'Super Administrator'
  },
  {
    id: '321846',
    name: 'Anette Black',
    status: { label: 'Inactive', value: 'inactive' },
    email: 'anette.black@gmail.com',
    phone: '(704) 555-0227',
    role: 'Super Administrator'
  },
  {
    id: '233222',
    name: 'Leslie Alexander',
    status: { label: 'Active', value: 'active' },
    email: 'theresa.webb@gmail.com',
    phone: '(704) 355-0127',
    role: 'Administrator'
  }
];
